<template>
  <div class="col s12 l1">
    <div class="filter-button_wrapper">
      <button
        type="button"
        class="btn btn-block blue"
        @click="toogleActionBox"
      >
        <i class="material-icons">dehaze</i>
      </button>
    </div>
    <div
      v-if="showActionBox"
      class="container"
    >
      <div class="column filters white-bg">
        <ul class="collection">
          <li
            v-for="action in actions"
            :key="action.label"
            class="collection-item"
            @click="doAction(action)"
          >
            <p>{{ action.label }}</p>
          </li>
        </ul>
      </div>
    </div>
    <filter-email-modal
      v-if="showModal"
      :show="showModal"
      :active-filters="activeFilters"
      @modal-close="showModal"
    />
  </div>
</template>

<script>
  export default {
    name: 'DropDown',

    props: {
      actions: {
        type: Array,
        default () {
          return []
        },
      },
      activeFilters: {
        type: Object,
        default () {
          return {}
        },
      },
    },
    data () {
      return { showActionBox: false, showModal: false }
    },
    methods: {
      toogleActionBox: function () {
        this.showActionBox = !this.showActionBox
      },
      getLabel: function (action) {
        let returnString = `<p> ${action.label}`

        returnString += ' </p>'
        return returnString
      },
      doAction: function (action) {
        this.showModal = !this.showModal
      },
    },
  }
</script>
